<template>
  <header class="section_plan wf-section inherited-styles-for-exported-element">
    <monthly-desktop :occurrence="'quarterly'" @success="successDesktop"/>
    <monthly-mobile :occurrence="'quarterly'" @success="successMobile"/>
    <div class="padding-global">
      <div class="container-medium">
        <div class="plan_component">
          <div class="wrap-content">
            <div class="heading_wrap text-color-light text-align-center">
              <h1 class="display-inline heading-style-h2" v-html="$t('components.plans.trends.title')"></h1><img src="https://uploads-ssl.webflow.com/63a1b54c23a6b7879791f4a4/63a4e92714e99ca21be10f88_stop-foguete-onfire.png" loading="lazy" sizes="(max-width: 479px) 33.59375px, (max-width: 767px) 36.796875px, (max-width: 1439px) 46.390625px, (max-width: 1919px) 3vw, 51.1875px" srcset="https://uploads-ssl.webflow.com/63a1b54c23a6b7879791f4a4/63a4e92714e99ca21be10f88_stop-foguete-onfire-p-500.png 500w, https://uploads-ssl.webflow.com/63a1b54c23a6b7879791f4a4/63a4e92714e99ca21be10f88_stop-foguete-onfire.png 602w" alt="" class="plan_image-logo">
            </div>
            <div class="plan_title-custom">
              <div class="plan_title-description-wrap">
                <div class="align-center text-align-center text-style-custom" v-html="$t('components.plans.trends.description')"></div>
              </div>
            </div>
          </div>
          <div class="pricing-table-wrapper">
            <div class="pricing-table-header">
              <div v-if="computedSelectedPlan == 'quarterly'" class="off_wrap text-color-light">
                <div class="text-size-small text-align-center text-weight-medium">{{ $t('components.plans.trends.card.header.discount.quarterly') }}</div>
              </div>
              <div v-else-if="computedSelectedPlan == 'semester'" class="off_wrap text-color-light">
                <div class="text-size-small text-align-center text-weight-medium">{{ $t('components.plans.trends.card.header.discount.semester') }}</div>
              </div>
              <div v-else-if="computedSelectedPlan == 'yearly'" class="off_wrap text-color-light">
                <div class="text-size-small text-align-center text-weight-medium">{{ $t('components.plans.trends.card.header.discount.yearly') }}</div>
              </div>
              <div class="pricing_wrap-header-content">
                <div class="toggle-wrapper table mb-0">
                  <div class="toggle-bg table">
                    <div @click="selectedPlan = 'monthly'" class="toggle-text monthly">
                      <div v-if="computedSelectedPlan == 'monthly'" class="toggle-btn table"></div>
                      {{ $t('components.plans.trends.card.header.occurrence.monthly') }}
                    </div>
                    <div @click="selectedPlan = 'quarterly'" class="toggle-text monthly">
                      <div v-if="computedSelectedPlan == 'quarterly'" class="toggle-btn table" style="width: 114px !important;"></div>
                      {{ $t('components.plans.trends.card.header.occurrence.quarterly') }}
                    </div>
                  </div>
                </div>
                <div class="pricing-table-header-cols w-row">
                  <div class="pricing-table-cols w-col w-col-4 w-col-small-4 w-col-tiny-4">
                    <div class="pricing-card-header table mb-0">
                      <div class="pricing-table-price-block custom-pricing responsive-style-align-center">
                        <div class="pricing-table-price-block">
                          <div class="pricing-currency v2">{{ computedFormattedCurrency }}</div>
                          <div class="pricing_wrap-data text-align-left">
                            <div class="price_yearly text-color-light-3">
                              <div v-if="computedSelectedPlan == 'quarterly'" class="price_wrap-money-bad">
                                <div class="pricing-price v2 yearly-price style-custom">{{ user.diamond_config.monthly.amount }}</div>
                                <div class="line"></div>
                              </div>
                              <div v-else-if="computedSelectedPlan == 'monthly' && computedShowDiscount" class="price_wrap-money-bad">
                                <div class="pricing-price v2 yearly-price style-custom">{{  parseInt(computedPlan.amount) }}</div>
                                <div class="line"></div>
                              </div>
                              <div v-else-if="computedSelectedPlan == 'yearly'" class="price_wrap-money-bad">
                                <div class="pricing-price v2 yearly-price style-custom">{{  parseInt(user.diamond_config.monthly.amount) }}</div>
                                <div class="line"></div>
                              </div>
                              <div v-else-if="computedSelectedPlan == 'semester'" class="price_wrap-money-bad">
                                <div class="pricing-price v2 yearly-price style-custom">{{  parseInt(user.diamond_config.monthly.amount) }}</div>
                                <div class="line"></div>
                              </div>
                              <div class="price_wrap-money-nice">
                                <div v-if="computedSelectedPlan == 'quarterly' || computedSelectedPlan == 'semester' || computedSelectedPlan == 'yearly' || (computedSelectedPlan == 'monthly' && computedShowDiscount)" class="text-size-tiny">{{ $t('components.plans.trends.card.header.price.for') }}</div>
                                <div v-if="computedSelectedPlan == 'monthly' && computedShowDiscount && computedPlan.coupon && computedPlan.coupon.amount_off" class="pricing-price v2 yearly-price">{{ parseInt(computedPlan.amount - computedPlan.coupon.amount_off) }}</div>
                                <div v-else-if="computedSelectedPlan == 'monthly' && computedShowDiscount && computedPlan.coupon && computedPlan.coupon.percent_off" class="pricing-price v2 yearly-price">{{ parseInt(computedPlan.amount - (computedPlan.amount * (computedPlan.coupon.percent_off / 100))) }}</div>
                                <div v-else class="pricing-price v2 yearly-price" :class="{'style-custom': computedSelectedPlan == 'monthly'}">{{ parseInt(computedPlan.amount) }}</div>
                                <div v-if="!computedShowDiscount" class="description_wrap-money">
                                  <div class="text-size-tiny">{{ $t('components.plans.trends.card.header.price.perMonth') }}</div>
                                </div>
                                <div v-if="!computedShowDiscount && computedSelectedPlan == 'quarterly'" class="description_wrap-money">
                                  <div class="text-size-tiny">{{ $t('components.plans.trends.card.header.price.quarterlyCharged') }}</div>
                                </div>
                                <div v-if="!computedShowDiscount && computedSelectedPlan == 'semester'" class="description_wrap-money">
                                  <div class="text-size-tiny">{{ $t('components.plans.trends.card.header.price.semesterCharged') }}</div>
                                </div>
                                <div v-if="!computedShowDiscount && computedSelectedPlan == 'yearly'" class="description_wrap-money">
                                  <div class="text-size-tiny">{{ $t('components.plans.trends.card.header.price.yearlyCharged') }}</div>
                                </div>
                                <div v-if="!computedShowDiscount && computedSelectedPlan == 'monthly'" class="description_wrap-money">
                                  <div class="text-size-tiny">{{ $t('components.plans.trends.card.header.price.monthlyCharged') }}</div>
                                </div>
                                <div v-if="computedShowDiscount" class="description_wrap-money">
                                  <div class="text-size-tiny">{{ $t('components.plans.trends.card.header.price.firstCharge') }}</div>
                                </div> 
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="buttons_wrap d-block text-center">
                  <stripe-checkout
                    ref="checkoutRef"
                    :pk="user.stripe_public_key"
                    :session-id="sessionId"
                  />
                  <div class="bg-white text-center" v-if="computedHasTrial" style="padding: 2px 8px;border-radius:2px;transform: rotate(-1deg);width: 110% !important;margin-left: -5%;margin-bottom: 10px;">
                    <p class="m-0" style="font-size:14px;background: linear-gradient(180deg, #F29932 0%, #E75341 100%);-webkit-background-clip: text;-webkit-text-fill-color: transparent;background-clip: text;text-fill-color: transparent;">
                      {{ $t('components.plans.trends.card.header.cta.trial',  { trialDays: this.computedTrial }) }}
                    </p>
                  </div>
                  <button v-if="computedPlan.gateway == 'stripe'" @click="goToStripeCheckout(computedPlan.stripe_id)" :disabled="computedIsLoading" class="button-primary is-light is-small w-button" style="width: 8rem ;">
                    <template v-if="computedIsLoading">
                      <i class="fe fe-loader"></i>
                    </template>
                    <template v-else-if="computedHasTrial">
                      {{ $t('components.plans.diamond.card.header.cta.testNow') }}
                    </template>
                    <template v-else>
                      {{ $t('components.plans.diamond.card.header.cta.subscribe') }}
                    </template>
                  </button>
                </div>
              </div>
            </div>
            <div class="pricing_wrap-description">
              <div class="pricing-table-category">
                <div class="pricing-table-row">
                  <div class="pricing-table-row-title">
                    <div class="pricing-card-row mobile-center">
                      <div class="pricing-row-text title">{{ $t('components.plans.trends.card.body.benefits.topProducts.title') }}</div>
                    </div>
                  </div>
                  <div class="pricing-table-row-cols w-row">
                    <div class="w-col w-col-4 w-col-small-4 w-col-tiny-4">
                      <div class="pricing-table-content">
                        <div class="pricing-card-row center">
                          <div class="pricing-icon table"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pricing-table-row">
                  <div class="pricing-table-row-title">
                    <div class="pricing-card-row mobile-center">
                      <div class="pricing-row-text title">{{ $t('components.plans.trends.card.body.benefits.competitiveAnalysis.title') }}</div>
                    </div>
                  </div>
                  <div class="pricing-table-row-cols w-row">
                    <div class="w-col w-col-4 w-col-small-4 w-col-tiny-4">
                      <div class="pricing-table-content">
                        <div class="pricing-card-row center">
                          <div class="pricing-icon table"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pricing-table-row">
                  <div class="pricing-table-row-title">
                    <div class="pricing-card-row mobile-center">
                      <div class="pricing-row-text title">{{ $t('components.plans.trends.card.body.benefits.seo.title') }}</div>
                    </div>
                  </div>
                  <div class="pricing-table-row-cols w-row">
                    <div class="w-col w-col-4 w-col-small-4 w-col-tiny-4">
                      <div class="pricing-table-content">
                        <div class="pricing-card-row center">
                          <div class="pricing-icon table"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pricing-table-row">
                  <div class="pricing-table-row-title">
                    <div class="pricing-card-row mobile-center">
                      <div class="pricing-row-text title">{{ $t('components.plans.trends.card.body.benefits.mining.title') }}</div>
                    </div>
                  </div>
                  <div class="pricing-table-row-cols w-row">
                    <div class="w-col w-col-4 w-col-small-4 w-col-tiny-4">
                      <div class="pricing-table-content">
                        <div class="pricing-card-row center">
                          <div class="pricing-icon table"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pricing-table-row">
                  <div class="pricing-table-row-title">
                    <div class="pricing-card-row mobile-center">
                      <div class="pricing-row-text title">{{ $t('components.plans.trends.card.body.benefits.basicFilters.title') }}</div>
                    </div>
                  </div>
                  <div class="pricing-table-row-cols w-row">
                    <div class="w-col w-col-4 w-col-small-4 w-col-tiny-4">
                      <div class="pricing-table-content">
                        <div class="pricing-card-row center">
                          <div class="pricing-icon table"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pricing-table-category">
                <div class="pricing-table-row">
                  <div class="pricing-table-row-title">
                    <div class="pricing-card-row mobile-center">
                      <div class="pricing-row-text title">{{ $t('components.plans.trends.card.body.benefits.marketAnalysis.title') }}</div>
                    </div>
                  </div>
                  <div class="pricing-table-row-cols w-row">
                    <div class="w-col w-col-4 w-col-small-4 w-col-tiny-4">
                      <div class="pricing-table-content">
                        <div class="pricing-card-row center">
                          <div class="pricing-icon table"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pricing-table-row responsive-style-align-center">
                  <div class="pricing-table-row-title">
                    <div class="pricing-card-row mobile-center">
                      <div class="pricing-row-text title">{{ $t('components.plans.trends.card.body.benefits.collection.title') }}</div>
                    </div>
                  </div>
                  <div class="pricing-table-row-cols w-row">
                    <div class="w-col w-col-4 w-col-small-4 w-col-tiny-4">
                      <div class="pricing-table-content">
                        <div class="pricing-card-row center">
                          <div class="pricing-icon table"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pricing-table-row">
                  <div class="pricing-table-row-title">
                    <div class="pricing-card-row mobile-center">
                      <div class="pricing-row-text title">{{ $t('components.plans.trends.card.body.benefits.testingMat.title') }}</div>
                    </div>
                  </div>
                  <div class="pricing-table-row-cols w-row">
                    <div class="w-col w-col-4 w-col-small-4 w-col-tiny-4">
                      <div class="pricing-table-content">
                        <div class="pricing-card-row center">
                          <div class="pricing-icon table"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pricing-table-row">
                  <div class="pricing-table-row-title">
                    <div class="pricing-card-row mobile-center">
                      <div class="pricing-row-text title">{{ $t('components.plans.trends.card.body.benefits.providers.title') }}</div>
                    </div>
                  </div>
                  <div class="pricing-table-row-cols w-row">
                    <div class="w-col w-col-4 w-col-small-4 w-col-tiny-4">
                      <div class="pricing-table-content">
                        <div class="pricing-card-row center">
                          <div class="pricing-icon table"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pricing-table-row">
                  <div class="pricing-table-row-title">
                    <div class="pricing-card-row mobile-center">
                      <div class="pricing-row-text title">{{ $t('components.plans.trends.card.body.benefits.productDetails.title') }}</div>
                    </div>
                  </div>
                  <div class="pricing-table-row-cols w-row">
                    <div class="w-col w-col-4 w-col-small-4 w-col-tiny-4">
                      <div class="pricing-table-content">
                        <div class="pricing-card-row center">
                          <div class="pricing-icon table"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pricing-table-row">
                  <div class="pricing-table-row-title">
                    <div class="pricing-card-row mobile-center">
                      <div class="pricing-row-text title">{{ $t('components.plans.trends.card.body.benefits.productCreatives.title') }}</div>
                    </div>
                  </div>
                  <div class="pricing-table-row-cols w-row">
                    <div class="w-col w-col-4 w-col-small-4 w-col-tiny-4">
                      <div class="pricing-table-content">
                        <div class="pricing-card-row center">
                          <div class="pricing-icon table"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pricing-table-row">
                  <div class="pricing-table-row-title">
                    <div class="pricing-card-row mobile-center">
                      <div class="pricing-row-text title">{{ $t('components.plans.trends.card.body.benefits.importProduct.title') }}</div>
                    </div>
                  </div>
                  <div class="pricing-table-row-cols w-row">
                    <div class="w-col w-col-4 w-col-small-4 w-col-tiny-4">
                      <div class="pricing-table-content">
                        <div class="pricing-card-row center">
                          <div class="pricing-icon table"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pricing-table-row">
                  <div class="pricing-table-row-title">
                    <div class="pricing-card-row mobile-center">
                      <div class="pricing-row-text title">{{ $t('components.plans.trends.card.body.benefits.nitro.title') }}</div>
                    </div>
                  </div>
                  <div class="pricing-table-row-cols w-row">
                    <div class="w-col w-col-4 w-col-small-4 w-col-tiny-4">
                      <div class="pricing-table-content">
                        <div class="pricing-card-row center">
                          <div class="pricing-row-text title">{{ $t('components.plans.trends.card.body.benefits.nitro.value', { amount: parseInt(computedPlan.nitro_amount) }) }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pricing-table-row">
                  <div class="pricing-table-row-title">
                    <div class="pricing-card-row mobile-center">
                      <div class="pricing-row-text title">{{ $t('components.plans.trends.card.body.benefits.premiumLib.title') }}</div>
                    </div>
                  </div>
                  <div class="pricing-table-row-cols w-row">
                    <div class="w-col w-col-4 w-col-small-4 w-col-tiny-4">
                      <div class="pricing-table-content">
                        <div class="pricing-card-row center">
                          <div class="pricing-row-text title">{{ $t('components.plans.trends.card.body.benefits.premiumLib.value', { franchise: parseInt(computedPlan.franchise/1000) }) }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pricing-table-category">
                <div class="pricing-table-row">
                  <div class="pricing-table-row-title">
                    <div class="pricing-card-row mobile-center">
                      <div class="pricing-row-text title">{{ $t('components.plans.trends.card.body.benefits.advancedSearch.title') }}</div>
                    </div>
                  </div>
                  <div class="pricing-table-row-cols w-row">
                    <div class="w-col w-col-4 w-col-small-4 w-col-tiny-4">
                      <div class="pricing-table-content">
                        <div class="pricing-card-row center">
                          <div class="pricing-icon table"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pricing-table-category">
                <div class="pricing-table-row">
                  <div class="pricing-table-row-title">
                    <div class="pricing-card-row mobile-center">
                      <div class="pricing-row-text title">{{ $t('components.plans.trends.card.body.benefits.creativesDownload.title') }}</div>
                    </div>
                  </div>
                  <div class="pricing-table-row-cols w-row">
                    <div class="w-col w-col-4 w-col-small-4 w-col-tiny-4">
                      <div class="pricing-table-content">
                        <div class="pricing-card-row center">
                          <div class="pricing-icon table"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pricing-table-row">
                  <div class="pricing-table-row-title">
                    <div class="pricing-card-row mobile-center">
                      <div class="pricing-row-text title">{{ $t('components.plans.trends.card.body.benefits.ia.title') }}</div>
                    </div>
                  </div>
                  <div class="pricing-table-row-cols w-row">
                    <div class="w-col w-col-4 w-col-small-4 w-col-tiny-4">
                      <div class="pricing-table-content">
                        <div class="pricing-card-row center">
                          <div class="pricing-icon table"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pricing-table-row">
                  <div class="pricing-table-row-title">
                    <div class="pricing-card-row mobile-center">
                      <div class="pricing-row-text title">{{ $t('components.plans.trends.card.body.benefits.copy.title') }}</div>
                    </div>
                  </div>
                  <div class="pricing-table-row-cols w-row">
                    <div class="w-col w-col-4 w-col-small-4 w-col-tiny-4">
                      <div class="pricing-table-content">
                        <div class="pricing-card-row center">
                          <div class="pricing-icon table"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pricing-table-row">
                  <div class="pricing-table-row-title">
                    <div class="pricing-card-row mobile-center">
                      <div class="pricing-row-text title">{{ $t('components.plans.trends.card.body.benefits.tecFilters.title') }}</div>
                    </div>
                  </div>
                  <div class="pricing-table-row-cols w-row">
                    <div class="w-col w-col-4 w-col-small-4 w-col-tiny-4">
                      <div class="pricing-table-content">
                        <div class="pricing-card-row last center">
                          <div class="pricing-icon table"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import { StripeCheckout } from '@vue-stripe/vue-stripe';

  import MonthlyMobile from '@/components/plans/modals/MonthlyMobile.vue';
  import MonthlyDesktop from '@/components/plans/modals/MonthlyDesktop.vue';
  
export default {
    name: 'DiamondPlan',
    components: {
      StripeCheckout,
      MonthlyMobile,
      MonthlyDesktop,
  },
  props: {
    user: {
      type: Object,
    },
  },
  data() {
    return {
      selectedPlan: 'monthly',
      sessionId: null,
      isLoading: false,
    };
  },
  computed: {
    getCheckout() {
      return this.$store.getters.getCheckout;
    },
    computedSelectedPlan() {
      return this.selectedPlan || 'quarterly';
    },
    computedPlan() {
      if (this.selectedPlan == 'quarterly') {
        return this.user.diamond_config.quarterly;
      } else if (this.selectedPlan == 'monthly') {
        return this.user.diamond_config.monthly;
      } else if (this.selectedPlan == 'semester') {
        return this.user.diamond_config.semester;
      } else {
        return this.user.diamond_config.yearly;
      }
    },
    computedHasTrial() {
      return this.computedPlan && this.computedPlan.trial_days > 0 && this.selectedPlan == 'monthly';
    },
    computedTrial() {
      return this.computedPlan.trial_days;
    },
    computedHasDiscount() {
      if (this.selectedPlan == 'quarterly') {
        return this.user.diamond_config.quarterly.coupon;
      } else {
        return this.user.diamond_config.monthly.coupon;
      }
    },
    computedDiscountText(){
      let plan;

      if (this.selectedPlan == 'quarterly') {
        plan = this.user.diamond_config.quarterly;
      }else {
        plan = this.user.diamond_config.monthly;
      }

      if (plan.coupon.amount_off) {
        return `${this.computedFormattedCurrency}${plan.coupon.amount_off}`
      } else {
        return `${plan.coupon.percent_off}%`
      }
    },
    computedFormattedCurrency() {
      if (this.user.currency == 'BRL') {
        return 'R$';
      } else if (this.user.currency == 'EUR') {
        return '€'
      } else if (this.user.currency == 'USD') {
        return 'US$'
      } else {
        return 'R$'
      }
    },
    computedHasAffiliate(){
      return this.user.affiliate_name;
    },
    // Desconto exibido na UI: só quando há coupon e NÃO é de influencer (affiliate)
    computedShowDiscount() {
      // Coupon discount UI off — show plan amount only. Re-enable:
      // return this.computedHasDiscount && !this.computedHasAffiliate;
      return false;
    },
    computedIsLoading() {
      return this.isLoading || false;
    },
  },
  methods: {
    goToStripeCheckout(stripe_id) {
      let isTrial = this.computedHasTrial
      
      let successUrl = `${process.env.VUE_APP_TRENDS_FRONT_URL}/checkout/success?session_id={CHECKOUT_SESSION_ID}`
      let cancelUrl = `${process.env.VUE_APP_APP_URL}/plano-recomendado`

      const data = {
        mode: 'subscription',
        price_id: stripe_id,
        cancel_url: cancelUrl,
        has_trial: isTrial,
        success_url: successUrl
      };

      this.$mixpanel.track('register_front_clicked_subscribe', { 
        email: this.user.email, 
        plan_kind: 'diamond',
        occurrence: this.selectedPlan,
        gateway: 'stripe', 
      });
      this.isLoading = true;
      this.$store.dispatch('createCheckout', data);
    },
    showModal() {
      if(this.computedHasAffiliate){
        return;
      }
      if(window.innerWidth < 600){
        this.$modal.show('modal-mobile');
      }else{
        this.$modal.show('modal-desktop');
      }
    },
    successDesktop(){
      this.$modal.hide('modal-desktop');
      return this.selectedPlan = 'quarterly';
    },
    successMobile() {
      this.$modal.hide('modal-mobile');
      return this.selectedPlan = 'quarterly';
    },
  },
  watch: {
    getCheckout(checkout) {
      if (checkout.session_id) {
        this.$segment.identify(this.user.id, {
          email: this.user.email,
          name: this.user.name,
          phone: this.user.phone,
          interest: this.user.interest,
          sales_range: this.user.sales_range
        });
        this.$segment.track('initiate_checkout', {
          revenue: this.selectedPlan == 'quarterly' ? this.computedPlan.amount * 3 : this.computedPlan.amount,
          products: [{
            id: this.computedPlan.stripe_id,
            currency: this.user.currency,
            quantity: 1,
            price: this.selectedPlan == 'quarterly' ? this.computedPlan.amount * 3 : this.computedPlan.amount
          }] 
        });

        this.sessionId = checkout.session_id;
        this.$refs.checkoutRef.redirectToCheckout();
        this.isLoading = false;
      }
    },
  },
  mounted() {
  },
};
</script>

<style>
.monthly-text{
  background: linear-gradient(180deg, #F29932 0%, #E75341 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: bold !important;
}
</style>
